export type ItemGroup = {
  name: string
  value: number
}

export const ITEM_GROUP: ItemGroup[] = [
  { name: 'All', value: 0 },
  { name: 'Product', value: 2 },
  { name: 'Service', value: 1 },
  // { name: 'Drug', value: 15 },
  // { name: 'Consumable', value: 20 },
]
